import { t, Text } from '@kanbios/ui';

/**
 * « +N » after the first item of a table cell, the others named in its
 * tooltip. D58: never a badge after a text in a table, so a word of the cell,
 * not a badge.
 */
export function MoreCount({ n, title }: { n: number; title?: string }) {
  if (n <= 0) return null;
  return <Text variant="body-sm" tone="mute" title={title}>{t('servers.moreApps', { n })}</Text>;
}
